import { createModel } from '@rematch/core';
import { ClubApi } from '../../services';
import { notifyError } from '../../utils/helpers';
import { reducerActions } from '../reducer';

import 'react-toastify/dist/ReactToastify.css';

const initialState = {
    allClubs: [],
    clubsByGenderAndType: []
};

export const club = createModel()({
    state: initialState,
    reducers: reducerActions,
    effects: dispatch => ({
        async getAllClubs() {
            dispatch.club.setError(null);
            try {
                const { data } = await ClubApi.allClubs();

                dispatch.club.setState({
                    allClubs: data.data
                });
                return data.data;
            } catch (err) {
                notifyError(err.response.data.message);
            }
        },
        async getClubsByGenderAndType({ gender, type }) {
            dispatch.club.setError(null);
            try {
                const { data } = await ClubApi.getNationalities({
                    gender,
                    type
                });

                dispatch.club.setState({
                    clubsByGenderAndType: data.data
                });
                return data.data;
            } catch (err) {
                notifyError(err.response.data.message);
            }
        },
        async reset() {
            await Promise.all([dispatch.club.setState(initialState)]);
        }
    })
});
